var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.$parent.$data.uploading && _vm.$parent.$props.canClear && _vm.$attrs.files.length > 0 ? _c("div", {
    staticClass: "tool-bar",
    on: {
      click: _vm.deleteAll
    }
  }, [_c("i", {
    staticClass: "fas fa-trash-alt",
    attrs: {
      title: "Delete"
    }
  }), _vm._v(" Remove all files ")]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };